/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsUpgrade } from "../../funcs/subscriptionsUpgrade.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string(),
  upgradeSubscriptionRequestEntity:
    components.UpgradeSubscriptionRequestEntity$inboundSchema,
};

export const tool$subscriptionsUpgrade: ToolDefinition<typeof args> = {
  name: "subscriptions-upgrade",
  description: `Upgrade a subscription to a different product

Upgrade a subscription to a different product or plan. Handle proration and plan changes seamlessly.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsUpgrade(
      client,
      args.id,
      args.upgradeSubscriptionRequestEntity,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
